<template>
  <div
    class="intro-y flex flex-col lg:flex-row justify-between lg:items-end gap-0 lg:gap-2 mt-8"
  >
    <div class="flex flex-row items-end">
      <div
        class="bg-green-700 px-8 py-2 lg:text-2xl font-bold text-white text-center rounded-md"
      >
        CL
      </div>
      <h2 class="text-lg font-medium ml-4">
        {{ formCL.clEdit ? 'แก้ไข ' + formCL.clNo : 'สร้าง CL' }}
      </h2>
      <OverBudget />
    </div>
    <div
      class="flex flex-row justify-end mt-4 lg:mt-0 gap-2"
      v-if="!loadingPage"
    >
      <router-link
        type="button"
        :to="{ name: 'reimbursementClMyWait' }"
        class="btn box text-gray-700 flex items-center"
      >
        <ArrowLeftIcon class="w-4 h-4 mr-2 hidden md:block" /> Back
      </router-link>
      <a
        href="javascript:;"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        data-toggle="modal"
        data-target="#cancel-modal-preview"
        :disabled="btnCancel.disabled"
        v-show="!btnCancel.hide"
      >
        <XCircleIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnCancel.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ยกเลิกเอกสาร
      </a>
      <button
        type="button"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        @click.prevent="rejectCL()"
        :disabled="btnReject.disabled"
        v-show="!btnReject.hide"
      >
        <ArrowLeftIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnReject.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ดึงเอกสารกลับ
      </button>
      <button
        type="button"
        class="btn box text-gray-700 disabled:opacity-50 flex items-center"
        @click.prevent="saveCL(true)"
        :disabled="btnDraft.disabled"
        v-show="!btnDraft.hide"
      >
        <FileTextIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnDraft.loading"
        />
        <LoadingIcon icon="oval" color="blue" v-else class="w-4 h-4 mr-2" />
        บันทึกแบบร่าง
      </button>
      <button
        type="button"
        class="btn btn-primary disabled:opacity-50 flex items-center"
        @click.prevent="saveCL(false)"
        :disabled="btnSave.disabled"
        v-show="!btnSave.hide"
      >
        <FileTextIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnSave.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        บันทึก และส่งอนุมัติ
      </button>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-6 mt-0 lg:mt-5">
    <div class="intro-y col-span-12">
      <div class="mt-5">
        <div class="h-10 w-full text-center my-20" v-if="loadingPage">
          <LoadingIcon icon="oval" class="w-12 h-12" />
        </div>
        <div class="horizontal-form" v-else>
          <div class="mb-5" v-if="formCL.isEdit">
            <DocumentPath
              :document-path="formCL.documentPathArray"
              :status-code="formCL.statusCode"
              :next-status-code="formCL.nextStatus"
              :approve-result="formCL.approveResultArray"
            />
          </div>
          <!-- header -->
          <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5">
            <div class="col-span-1 md:mr-4 box flex flex-col justify-center">
              <div
                class="w-full h-auto flex flex-row justify-center bg-white p-4"
              >
                <img
                  v-if="companyDefault"
                  :src="companyDefault.comp_logo_url"
                  class=""
                  alt=""
                />
              </div>
            </div>
            <div class="col-span-2 lg:col-span-4 mt-4 md:mt-0">
              <div class="intro-y box p-5">
                <div class="flex flex-col lg:flex-row lg:space-x-4">
                  <div class="text-theme-6">
                    ตำแหน่งเอกสาร : ผู้ขอเบิกสร้างเอกสาร
                  </div>
                  <div class="text-theme-10">
                    ผู้ดำเนินการ : {{ userInfo ? userInfo.fullname : '' }}
                  </div>
                </div>
              </div>
              <div class="intro-y box p-5 mt-5 lg:flex lg:justify-between">
                <div>
                  <div>สายอนุมัติของผู้เปิดเอกสาร :</div>
                  <div class="font-bold">
                    {{
                      documentPathText
                        ? documentPathText.join(' -> ')
                        : 'ไม่ระบุ'
                    }}
                  </div>
                </div>
                <div>
                  <select
                    v-model="specialPathSelected"
                    class="form-control form-select"
                    @change="
                      onChangeDocumentPath({ target: 'select-special-path' })
                    "
                  >
                    <option :value="null"
                      >ตรวจสอบสายอนุมัติของผู้เปิดเอกสารตามวงเงิน</option
                    >
                    <option
                      v-for="spacialPath in documentSpacialPathOptions"
                      :key="spacialPath.name"
                      :value="spacialPath.name"
                      >{{ spacialPath.name }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- cl header -->
          <div class="intro-y box p-5 mt-5">
            <div class="text-lg font-bold">ข้อมูลผู้สร้างเอกสาร</div>
            <!-- ชื่อผู้ขอเบิก -->
            <div class="grid grid-cols-1 lg:grid-cols-4 gap-4 mt-5">
              <div>
                <div class="w-full">
                  <label class="form-label"
                    >ชื่อผู้ขอเบิก<span
                      class="text-theme-6"
                      v-show="lockField.status"
                      >{{ lockField.label }}</span
                    ></label
                  >
                  <div class="preview w-full">
                    <WfSelectSingleEmployee
                      :disabled="lockField.status"
                      key="wfselect-employee"
                      v-model="formCL.employeeSelected"
                      :showBtnClear="false"
                      :options="{
                        searchMinLength: 3
                      }"
                      @change="onChangeDocumentPath"
                    ></WfSelectSingleEmployee>
                  </div>
                </div>
              </div>
              <div>
                <label class="form-label"
                  >หน่วยงาน / บริษัท<span
                    class="text-theme-6"
                    v-show="lockField.status"
                    >{{ lockField.label }}</span
                  ></label
                >
                <select
                  name=""
                  :disabled="lockField.status"
                  v-model="formCL.companySelected"
                  @change="onChangeDocumentPath({ target: 'select-company' })"
                  class="form-select w-full"
                >
                  <option
                    v-for="company in companyOptions"
                    :key="company.comp_no"
                    :value="company.comp_no"
                    >{{ company.comp_name_th }}</option
                  >
                </select>
              </div>
              <div>
                <label class="form-label">รหัสหน่วยงาน</label>
                <div class="" v-if="employeeDefault">
                  {{ employeeDefault.bu_no }} ({{ employeeDefault.bu_name }})
                </div>
              </div>
              <div>
                <label class="form-label"
                  >เบอร์ติดต่อ <span class="text-theme-6">*</span></label
                >
                <div>
                  <input
                    type="text"
                    refs="titleRef"
                    v-model="validateCL.telephone.$model"
                    class="form-control w-full"
                    :class="{
                      'border-theme-6': validateCL.telephone.$error
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="intro-y box p-5 mt-5">
            <div class="font-bold text-lg">ข้อมูลด้านบัญชี</div>
            <div class="mt-4 lg:w-1/3">
              <div>
                <label class="form-label">สกุลเงิน</label>
                <div class="font-bold w-full">
                  <select
                    name=""
                    v-model="formCL.currencySelected"
                    class="form-select form-control"
                  >
                    <option
                      v-for="(currency, ind) in currencyOptions"
                      :key="ind"
                      :value="currency"
                      >{{ currency }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            <div class="mt-4 lg:w-1/3">
              <label class="form-label">ชำระโดย</label>
              <div>
                <select
                  name=""
                  v-model="formCL.cashSelected"
                  class="form-select form-control w-full"
                  @change="onChangeDocumentPath({ target: 'select-cash' })"
                >
                  <option
                    v-for="cash in cashOptions"
                    :key="cash.value"
                    :value="cash.value"
                    >{{ cash.label }}</option
                  >
                </select>
              </div>
            </div>
            <div class="mt-4 lg:w-1/3" v-show="showVendor">
              <label for="" class="form-label ">จ่ายให้ </label>
              <div class="preview w-full border-theme-6">
                <WfSelectSinglePayee
                  key="wfselect-payee"
                  v-model="validateCL.payeeSelected.$model"
                  :options="{
                    ajaxLimit: 50,
                    searchMinLength: 3,
                    filters: '&filterBy[]=vendor_code'
                  }"
                  class="border"
                  :class="{
                    'border-theme-6': validateCL.payeeSelected.$error
                  }"
                ></WfSelectSinglePayee>
              </div>
              <div class="text-theme-6 text-sm mt-2">
                * กรณีที่มีภาษีมูลค่าเพิ่มหรือภาษีหัก ณ ที่จ่าย ให้ระบุจ่ายให้
              </div>
            </div>
          </div>

          <div class="mt-5 intro-y box p-5">
            <div class="font-bold text-lg">ข้อมูลค่าใช้จ่าย</div>
            <div class="grid grid-cols-1 lg:grid-cols-4 lg:gap-4">
              <div class="col-span-3">
                <div class="mt-4">
                  <label class="form-label"
                    >รายละเอียด <span class="text-theme-6">*</span></label
                  >
                  <!-- <textarea
                    name=""
                    id=""
                    rows="7"
                    v-model="validateCL.detail.$model"
                    class="form-control"
                    :class="{
                      'border-theme-6': validateCL.detail.$error
                    }"
                    placeholder="เพิ่มเติม..."
                  ></textarea> -->
                  <div
                    :class="{
                      'border-theme-6 border': validateCL.detail.$error
                    }"
                  >
                    <TextEditor v-model="validateCL.detail.$model" />
                  </div>
                </div>
                <div class="mt-4">
                  <label for="" class="form-label"
                    >เลือกเอกสารจาก CA<span class="text-theme-6">*</span></label
                  >
                  <div>
                    <select
                      name=""
                      v-model="validateCL.caSelected.$model"
                      class="form-select form-control w-full"
                      :class="{
                        'border-theme-6': validateCL.caSelected.$error
                      }"
                    >
                      <option :value="null" key="0">-- Select CA --</option>
                      <option
                        v-for="ca in caOptions"
                        :key="ca.value"
                        :value="ca.value"
                        >{{ ca.label }}</option
                      >
                    </select>
                  </div>
                </div>
              </div>
              <div>
                <div class="mt-4">
                  <label for="" class="form-label">เลือกเอกสารจาก Memo</label>
                  <MemoAutoComplete
                    :options="memoOptions"
                    v-model="formCL.memoSelected"
                    v-model:selectedMemo="selectedMemo"
                  />
                  <!-- <div>
                    <select
                      name=""
                      v-model="formCL.memoSelected"
                      class="form-select form-control w-full"
                    >
                      <option :value="null" key="0">-- Select Memo --</option>
                      <option
                        v-for="memo in memoOptions"
                        :key="memo.value"
                        :value="memo.value"
                        >{{ memo.label }}</option
                      >
                    </select>
                  </div> -->
                </div>
                <div class="mt-4 col-span-1">
                  <label class="form-label"
                    >ไฟล์แนบ {{ fileUploadMaxSize }} MB</label
                  >
                  <AttachFileUpload module="cl" />
                </div>
              </div>
            </div>
          </div>

          <!-- items -->
          <div class="grid grid-cols-1 mt-5 box  intro-y" v-show="boxItemOpen">
            <div class="box p-5">
              <div class="text-lg font-bold mb-4">ระบุรายการเบิก</div>
              <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4">
                <div class="border p-5 rounded-lg">
                  <div class="text-lg mb-4">รายละเอียดค่าใช้จ่าย</div>
                  <div class="space-y-4">
                    <div class="">
                      <label for="" class="form-label "
                        >เลขที่ใบเสร็จ/ใบกำกับภาษี
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="formCLItem.receiptNo"
                        maxlength="50"
                        placeholder="(ไม่เกิน 50 ตัวอักษร)"
                      />
                    </div>
                    <div class="p-fluid p-grid">
                      <div class="p-field p-field-sm">
                        <label for=""
                          >วันที่เลขที่ใบเสร็จ/ใบกำกับภาษี/วันที่ทำรายการ
                        </label>
                        <Calendar
                          class="mt-2"
                          inputStyle="padding:0.5rem 0.75rem;"
                          v-model="formCLItem.receiptDate"
                          dateFormat="yy-mm-dd"
                          placeholder="2020-01-01"
                        />
                      </div>
                    </div>
                    <!-- <div class="">
                      <label for="" class="form-label "
                        >วันที่เลขที่ใบเสร็จ/ใบกำกับภาษี
                      </label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="formCLItem.receiptDate"
                      />
                    </div> -->
                    <div class="">
                      <label for="" class="form-label ">Vendor</label>
                      <div class="preview w-full">
                        <WfSelectSingleVendor
                          key="wfselect-vendor"
                          v-model="formCLItem.vendorSelected"
                          :options="{
                            ajaxLimit: 50,
                            searchMinLength: 3
                          }"
                        ></WfSelectSingleVendor>
                      </div>
                    </div>
                    <div class="">
                      <label for="" class="form-label "
                        >รายละเอียดค่าใช้จ่าย
                        <span class="text-theme-6">*</span></label
                      >
                      <textarea
                        name=""
                        id=""
                        rows="3"
                        v-model="validateItem.detail.$model"
                        :class="{
                          'border-theme-6': validateItem.detail.$error
                        }"
                        class="form-control"
                        placeholder="เพิ่มเติม..."
                      ></textarea>
                    </div>
                    <div class="">
                      <label for="" class="form-label ">จำนวนเงิน(บาท)</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="formCLItem.amount"
                        @keyup="calActualCost"
                        @change="calActualCost"
                      />
                    </div>
                    <div class="">
                      <label for="" class="form-label ">ภาษีมูลค่าเพิ่ม</label>
                      <div class="grid grid-cols-4 space-x-2">
                        <input
                          type="number"
                          class="form-control col-span-2"
                          min="0"
                          v-model.number="formCLItem.vat"
                          @keyup="calVat"
                          @change="calVat"
                        />
                        <input
                          type="number"
                          class="form-control"
                          v-model.number="formCLItem.taxVatDefault"
                          min="0"
                          max="100"
                          @keyup="calVatProcess"
                          @change="calVatProcess"
                        />
                        <button
                          class="btn"
                          :class="[
                            formCLItem.taxVatProcess
                              ? 'btn-primary'
                              : 'btn-secondary'
                          ]"
                          @click="
                            ;[
                              (formCLItem.taxVatProcess = !formCLItem.taxVatProcess),
                              calVatProcess()
                            ]
                          "
                        >
                          คำนวณ
                        </button>
                      </div>
                    </div>
                    <div class="">
                      <label for="" class="form-label "
                        >ภาษีหัก ณ ที่จ่าย</label
                      >
                      <div class="grid grid-cols-4 space-x-2">
                        <input
                          type="number"
                          class="form-control col-span-2"
                          min="0"
                          v-model.number="formCLItem.whTax"
                          @keyup="calTax"
                          @change="calTax"
                        />
                        <input
                          type="number"
                          class="form-control"
                          v-model.number="formCLItem.taxWhDefault"
                          min="0"
                          max="100"
                          @keyup="calTaxProcess"
                          @change="calTaxProcess"
                        />
                        <button
                          class="btn"
                          :class="[
                            formCLItem.taxWhProcess
                              ? 'btn-primary'
                              : 'btn-secondary'
                          ]"
                          @click="
                            ;[
                              (formCLItem.taxWhProcess = !formCLItem.taxWhProcess),
                              calTaxProcess()
                            ]
                          "
                        >
                          คำนวณ
                        </button>
                      </div>
                    </div>
                    <!-- <div class="form-check">
                      <input
                        id="isItselfTax"
                        type="checkbox"
                        class="form-check-input"
                        v-model="formCLItem.isItselfTax"
                      />
                      <label
                        for="isItselfTax"
                        class="form-check-label text-theme-6"
                        >บริษัทรับภาระเอง</label
                      >
                    </div> -->
                    <div class="">
                      <label for="" class="form-label ">ค่าใช้จ่ายจริง</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model="formCLItem.actualCost"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-span-2 mt-4 lg:mt-0">
                  <!-- budget -->
                  <div class="border p-5 rounded-lg">
                    <div class="text-lg mb-4">รายละเอียดงบประมาณ</div>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div class="mb-4">
                        <div class="mb-4">
                          <label for="" class="form-label "
                            >ค้นหางบประมาณหน่วยงาน</label
                          >
                          <div class="">
                            <a
                              class="w-full btn btn-warning"
                              href="javascript:;"
                              data-toggle="modal"
                              data-target="#modal-budget"
                            >
                              รายการงบประมาณหน่วยงาน
                            </a>
                          </div>
                        </div>
                        <div class="mb-4">
                          <label for="" class="form-label "
                            >ค้นหางบประมาณโครงการ</label
                          >
                          <div class="">
                            <a
                              class="w-full btn btn-warning"
                              :class="[
                                !isProjectBudgetEnable ? 'btn-disabled' : ''
                              ]"
                              href="javascript:;"
                              :data-toggle="
                                `${isProjectBudgetEnable ? 'modal' : ''}`
                              "
                              :data-target="
                                `${
                                  isProjectBudgetEnable ? '#modal-ledget' : ''
                                }`
                              "
                            >
                              รายการงบประมาณโครงการ
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="space-y-4">
                        <div class="">
                          <label for="" class="form-label ">ปีงบประมาณ</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formCLItem.budgetInfo.year"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label ">ชนิดงบประมาณ</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formCLItem.budgetInfo.bu_type"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label "
                            >ใช้งบประมาณของหน่วยงาน</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formCLItem.budgetInfo.bu_name"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label ">รหัส BU</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formCLItem.budgetInfo.bu_code"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label ">Account Code</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formCLItem.budgetInfo.account_code"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label ">Subsidiary</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formCLItem.budgetInfo.subsidiary"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label ">Account Name</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formCLItem.budgetInfo.account_name"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label ">Subledger No</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formCLItem.budgetInfo.subledger"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label "
                            >Subledger Name</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formCLItem.budgetInfo.subledger_name"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- btn save and cancal -->
              <div class="mt-4 flex">
                <button
                  type="button"
                  class="btn btn-primary disabled:opacity-50 mr-2 flex items-center"
                  @click.prevent="saveItem()"
                  :disabled="btnItemSave.disabled"
                  v-show="!btnItemSave.hide"
                >
                  <FileTextIcon
                    class="w-4 h-4 mr-2"
                    v-if="!btnItemSave.loading"
                  />
                  <LoadingIcon
                    icon="oval"
                    color="blue"
                    v-else
                    class="w-4 h-4 mr-2"
                  />
                  Save
                </button>
                <button class="btn ml-2" @click="clearFormItem()">
                  <Trash2Icon class="w-4 h-4 mr-2" />Cancel
                </button>
              </div>

              <!-- modal table -->
              <div
                id="modal-budget"
                class="modal"
                tabindex="-1"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-body p-10 text-center">
                      <TableBudget
                        v-model="formCLItem.budgetSelected"
                        @setBudget="setBudget"
                        :company="formCL.companySelected"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="modal-ledget"
                class="modal"
                tabindex="-1"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-body p-10 text-center">
                      <TableSubledget
                        v-model="formCLItem.budgetSubledgerSelected"
                        @setSubledget="setBudget"
                        :company="formCL.companySelected"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- รายการเบิก -->
          <div class="grid grid-cols-1 mt-5">
            <div class="box p-5">
              <!-- header -->
              <div class="md:flex md:justify-between pb-4">
                <div class="flex">
                  <div class="text-lg font-bold">รายการเบิก</div>
                  <OverBudget />
                </div>

                <div
                  class="col-span-2 flex flex-col gap-2 items-end mt-2 md:mt-0"
                >
                  <div class="flex flex-row items-center">
                    <div class="mr-2">
                      <span
                        >นำข้อมูลเข้าผ่าน
                        <a
                          :href="linkImportXlsx"
                          target="_blank"
                          class="text-theme-1 font-medium"
                          ><u>Excel template</u></a
                        ></span
                      >
                    </div>
                    <div class="flex flex-row">
                      <div class="w-6 h-6 mt-2 mr-2">
                        <LoadingIcon
                          icon="puff"
                          color="green"
                          v-show="importProcess"
                        />
                      </div>
                      <input
                        type="file"
                        ref="fileImport"
                        @change="importFile"
                        class="form-control w-56"
                      />
                    </div>
                  </div>
                  <div class="flex flex-row gap-2">
                    <button
                      class="btn bg-blue-300"
                      @click="toggleBoxItemOpen()"
                      v-if="
                        formCL.statusCode == 'CL_DRAFT' ||
                          formCL.statusCode === null
                      "
                    >
                      <PlusIcon
                        class="w-4 h-4 mr-2 hidden md:block"
                      />ระบุรายการเบิก
                    </button>
                    <button
                      class="btn btn-outline-primary"
                      type="button"
                      @click.stop="checkBudget()"
                    >
                      <CheckCircleIcon class="w-4 h-4 mr-2 hidden md:block" />
                      ตรวจสอบงบประมาณ
                    </button>
                  </div>
                </div>
              </div>
              <!-- table -->
              <div class="overflow-x-scroll">
                <table class="table">
                  <thead>
                    <tr class="bg-gray-700 text-white">
                      <th class="whitespace-nowrap text-center" width="5%">
                        ลำดับ
                      </th>
                      <!-- <th class="whitespace-nowrap text-center" width="10%">
                        เลขที่ใบเสร็จ/ใบกำกับภาษี
                      </th>
                      <th class="whitespace-nowrap text-center" width="10%">
                        วันที่เลขที่ใบเสร็จ/ใบกำกับภาษี
                      </th> -->
                      <th class="whitespace-nowrap text-center" width="65%">
                        รายละเอียด
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        จำนวนเงิน
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        ภาษี<br />มูลค่าเพิ่ม
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        ภาษีหัก ณ<br />ที่จ่าย
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        ค่าใช้จ่ายจริง
                      </th>
                      <th class="whitespace-nowrap text-center" width="10%">
                        จัดการ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-center" v-if="items.length == 0">
                      <td colspan="7" class="border-b">ไม่พบรายการ</td>
                    </tr>
                    <tr
                      v-for="(item, inx) in items"
                      :key="item.cl_item_id"
                      v-else
                    >
                      <td class="border-b-2 text-center">{{ inx + 1 }}.</td>
                      <td class="border-b-2">
                        <b>เลขที่ใบเสร็จ/ใบกำกับภาษี: </b>{{ item.receipt_no
                        }}<br />
                        <b>วันที่เลขที่ใบเสร็จ/ใบกำกับภาษี: </b
                        >{{ item.receipt_date }}<br />
                        <b>รายละเอียด: </b>
                        <p
                          v-html="
                            item.detail
                              ? item.detail.replaceAll('\n', '<br />')
                              : ''
                          "
                        ></p>
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.amount) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.vat) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.wh_tax) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.actual_cost) }}
                        <p
                          class="text-theme-6 font-bold"
                          v-show="item.isOverBudget"
                        >
                          *เกินงบประมาณ
                        </p>
                      </td>
                      <td class="text-right border-b-2">
                        <div
                          v-if="
                            formCL.statusCode == 'CL_DRAFT' ||
                              formCL.statusCode === null
                          "
                        >
                          <button
                            class="btn btn-sm"
                            :class="[
                              item.is_edit
                                ? 'btn-warning'
                                : 'btn-outline-warning'
                            ]"
                            @click="getCLItem(item.cl_item_id, inx)"
                          >
                            <EditIcon class="w-4 h-4" />
                          </button>
                          <a
                            href="javascript:;"
                            class="btn btn-sm btn-danger ml-2"
                            data-toggle="modal"
                            data-target="#delete-cl-item-modal-preview"
                            @click="setDeleteCLItem(item.cl_item_id)"
                          >
                            <Trash2Icon class="w-4 h-4" />
                          </a>
                        </div>
                        <div v-else>
                          <span class="text-theme-6">ไม่สามารถแก้ไขได้</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- ประเภทของงบประมาณ -->
          <div class="grid lg:grid-cols-2 gap-0 lg:gap-4">
            <div class="mt-5">
              <TableSummaryCost :items="formCL.itemSummary" />
            </div>
            <div class="mt-5" v-if="formCL.clEdit">
              <TableHistory :items="formCL.historyArray" />
            </div>
          </div>
        </div>
      </div>
      <!-- BEGIN: Modal Content -->
      <div
        id="delete-cl-item-modal-preview"
        class="modal"
        tabindex="-1"
        data-backdrop="static"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body p-0">
              <div class="p-5 text-center">
                <XCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
                <div class="text-3xl mt-5">คุณแน่ใจ</div>
                <div class="text-gray-600 mt-2">
                  ต้องการลบรายการนี้ ใช่ หรือ ไม่?
                </div>
              </div>
              <div class="px-5 pb-8 text-center">
                <button
                  type="button"
                  data-dismiss="modal"
                  class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1"
                  @click="cancelDeleteCLItem()"
                >
                  ไม่
                </button>
                <button
                  type="button"
                  data-dismiss="modal"
                  class="btn btn-danger w-24"
                  @click="confirmDeleteCLItem()"
                >
                  ใช่
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END: Modal Content -->
      <!-- BEGIN: Modal Content -->
      <ModalCancel
        module="reimbursement"
        doc-type="cl"
        :doc-id="formCL.clID"
        redirect-complete="reimbursementClMyWait"
      />
      <!-- END: Modal Content -->
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  computed,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  toRefs,
  watch
} from 'vue'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { api, apiImport } from '@/utils/api'
import alert from '@/helpers/alert'
import helpers from '@/helpers'
import { required, requiredIf } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

import OverBudget from '@/components/overBudget.vue'
import WfSelectSingleVendor from '@/components/select-single-vendor/Main.vue'
import WfSelectSingleEmployee from '@/components/select-single-employee/Main.vue'
import WfSelectSinglePayee from '@/components/select-single-payee/Main.vue'
import TableBudget from '@/components/table-budget/Main.vue'
import TableSubledget from '@/components/table-subledget/Main.vue'
import TableSummaryCost from '@/components/TableSummaryCost.vue'
import TableHistory from '@/components/TableHistory.vue'
import AttachFileUpload from '@/components/attach-file/Upload.vue'
import DocumentPath from '@/components/document-path/Main.vue'
import ModalCancel from '@/components/ModalCancel.vue'
import TextEditor from '@/components/TextEditor.vue'
import MemoAutoComplete from '@/components/MemoAutoComplete.vue'

export default defineComponent({
  components: {
    OverBudget,
    WfSelectSingleVendor,
    WfSelectSingleEmployee,
    WfSelectSinglePayee,
    TableBudget,
    TableSubledget,
    TableSummaryCost,
    AttachFileUpload,
    TableHistory,
    DocumentPath,
    ModalCancel,
    TextEditor,
    MemoAutoComplete
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()

    const loadingPage = computed(() => store.state.global.loadingPage)
    const companyOptions = computed(() => store.state.global.company)
    const companyDefault = computed(() => store.state.global.companyDefault)
    const employeeDefault = computed(() => store.state.global.employeeDefault)
    const currencyOptions = computed(() => store.state.global.currency)
    const cashOptions = computed(() => store.state.global.cash)
    const btnCancel = computed(() => store.state.cl.btnCancel)
    const btnSave = computed(() => store.state.cl.btnSave)
    const btnDraft = computed(() => store.state.cl.btnDraft)
    const btnReject = computed(() => store.state.cl.btnReject)
    const btnItemSave = computed(() => store.state.cl.btnItemSave)
    // const memoOptions = computed(() => store.getters['cl/memoOptions'])
    const memoOptions = computed(() => store.state.cl.memo)
    const caOptions = computed(() => store.getters['cl/caOptions'])
    const documentPath = computed(() => store.state.cl.documentPath)
    const files = computed(() => store.state.cl.files)
    const { numberFormat, numberFormat2, dateFormat, fillBorderColor } = helpers
    const fileUploadMaxSize = computed(
      () => store.state.global.fileUploadMaxSize
    )
    const linkImportXlsx = ref(process.env.VUE_APP_IMPORT_CL_XLSX)
    const isProjectBudgetEnable = ref(
      process.env.VUE_APP_PROJECT_BUDGET_ENABLE === 'true'
    )

    // store.getters('ca/getPayForDefault')

    const userInfo = computed(() => store.state.auth.info)
    const documentSpacialPathOptions = computed(
      () => store.state.global.documentSpacialPath
    )

    const documentPathText = computed(() => store.state.cl.documentPathText)
    const specialPathSelected = ref(null)
    // watch(specialPathSelected, newVal => {
    //   // console.log('watch special selected')
    //   store.dispatch('cl/loadDocumentPath', {
    //     compNo: companyDefault.value.comp_no,
    //     employeeId: formCL.employeeSelected,
    //     specialPath: newVal,
    //     cashSelected: formCL.cashSelected
    //   })
    // })

    const formCL = reactive({
      clID: route.params.id || null,
      isEdit: route.params.id || null,
      clEdit: route.params.id !== undefined,
      clNo: '',

      companySelected: store.state.auth.info.comp_no,
      telephone: store.state.global.employeeDefault.telephone,
      employeeSelected: store.state.auth.info.employeeId,

      currencySelected: store.state.global.currencyDefault,
      cashSelected: store.state.global.cashDefault,

      payeeSelected: null,
      payeeName: '',
      payeeNo: '',

      memoSelected: null,
      caSelected: null,
      detail: '',
      statusCode: null,
      itemSummary: [],
      historyArray: [],

      approveResultArray: [],
      documentPathArray: [],
      nextStatus: ''
    })

    const rulesCL = {
      telephone: { required },
      detail: { required },
      caSelected: { required },
      payeeSelected: {
        required: requiredIf(() => formCL.cashSelected === 'c')
      }
    }

    const validateCL = useVuelidate(rulesCL, toRefs(formCL))

    const selectedMemo = ref(null)

    const formCLItem = reactive({
      clItemID: null,
      vendorSelected: null,
      payeeSelected: null,
      budgetSelected: null,
      isItselfTax: false,
      budgetInfo: {
        year: '',
        bu_name: '',
        bu_code: '',
        bu_type: '',
        subledger: '',
        subsidiary: '',
        account_code: '',
        account_name: '',
        subledger_name: ''
      },
      budgetSubledgerSelected: null,
      bu_year: null,
      bu_name: null,
      receiptNo: null,
      receiptDate: new Date(),
      detail: null,
      amount: 0,
      vat: 0,
      whTax: 0,
      actualCost: 0,
      taxVatDefault: 7,
      taxWhDefault: 3,
      taxVatProcess: false,
      taxWhProcess: false
    })

    const saveCL = async isDraft => {
      validateCL.value.$touch()
      if (validateCL.value.$invalid) {
        alert.error()
        return false
      }
      validateCL.value.$reset()
      if (isDraft) {
        store.commit('cl/setBtnActiveFix', { type: 'btnDraft', status: true })
      } else {
        store.commit('cl/setBtnActiveFix', { type: 'btnSave', status: true })
      }
      const dataCL = {
        is_draft: isDraft,
        username: userInfo.value.username,
        employee_id: userInfo.value.employeeId,
        petty_cash: formCL.cashSelected,
        cl_comp: formCL.companySelected,
        special_path: specialPathSelected.value,
        document_path: documentPath.value,
        owner_id: userInfo.value.employeeId,
        owner_name: userInfo.value.fullname,
        bu_no: employeeDefault.value.bu_no,
        bu_name: employeeDefault.value.bu_name,
        telephone: formCL.telephone,
        req_id: employeeDefault.value.employee_id,
        req_name: employeeDefault.value.fullname_th,
        req_detail: fillBorderColor(formCL.detail),
        payee_no: '',
        payee_name: '',
        file_attach: await store.getters['cl/getFileAttach'],
        ememo_id: formCL.memoSelected,
        ememo_title: '',
        ca_id: '',
        ca_no: '',
        currency: formCL.currencySelected // สกุลเงิน
      }

      const caGet = store.getters['cl/caGet'](formCL.caSelected)
      if (caGet !== undefined) {
        dataCL.ca_id = caGet.ca_id
        dataCL.ca_no = caGet.ca_no
      }

      // const memoGet = store.getters['cl/memoGet'](formCL.memoSelected)
      // if (memoGet !== undefined) {
      //   dataCL.ememo_id = memoGet.id
      //   dataCL.ememo_title = memoGet.doc_no + ' - ' + memoGet.title
      // }
      if (selectedMemo.value) {
        dataCL.ememo_id = selectedMemo.value.id
        dataCL.ememo_title = `${selectedMemo.value.doc_no_full} - ${selectedMemo.value.title}`
      }

      if (formCL.payeeSelected) {
        dataCL.payee_no = formCL.payeeNo
        dataCL.payee_name = formCL.payeeName
      }

      if (!formCL.clEdit) {
        await api
          .post('/reimbursement/cl/insert', dataCL)
          .then(res => {
            if (res.code == 200) {
              formCL.clID = res.data.cl_id
              formCL.clEdit = true
              alertBudget(false, res.data.is_over_budget)
              store.commit('cl/setBtn', { type: 'btnCancel', value: 'hide' })
              alert.success()
            } else {
              store.commit('cl/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
              store.commit('cl/setBtnActiveFix', {
                type: 'btnSave',
                status: false
              })
              if (res.validator) {
                alert.validatorShow(res.validator)
              } else {
                alert.error(res.message)
              }
              return
            }
            if (isDraft) {
              store.commit('cl/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
            } else {
              router.push({
                name: 'reimbursementClFormDetail',
                params: { id: res.data.cl_id }
              })
            }
          })
          .catch(e => {
            alert.error(e.message)
            if (isDraft) {
              store.commit('cl/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
            } else {
              store.commit('cl/setBtnActiveFix', {
                type: 'btnSave',
                status: false
              })
            }
          })
      } else {
        await api
          .put(`/reimbursement/cl/update/${formCL.clID}`, dataCL)
          .then(res => {
            if (res.code == 200) {
              alertBudget(false, res.data.is_over_budget)
              alert.success()
            } else {
              store.commit('cl/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
              store.commit('cl/setBtnActiveFix', {
                type: 'btnSave',
                status: false
              })
              if (res.validator) {
                alert.validatorShow(res.validator)
              } else {
                alert.error(res.message)
              }
              return
            }
            if (isDraft) {
              store.commit('cl/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
            } else {
              router.push({
                name: 'reimbursementClFormDetail',
                params: { id: formCL.clID }
              })
            }
          })
          .catch(e => {
            alert.error(e.message)
            if (isDraft) {
              store.commit('cl/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
            } else {
              store.commit('cl/setBtnActiveFix', {
                type: 'btnSave',
                status: false
              })
            }
          })
      }
      reloadCL()
    }

    const saveItem = async () => {
      validateItem.value.$touch()
      if (!validateItem.value.$invalid) {
        store.commit('cl/setBtnActiveFix', {
          type: 'btnItemSave',
          status: true
        })
        if (formCL.clID === null) {
          await saveCL(true)
        }
        const dataItem = {
          cl_id: formCL.clID,
          receipt_no: formCLItem.receiptNo,
          receipt_date: dateFormat(formCLItem.receiptDate),
          vendor_no: formCLItem.vendorSelected
            ? formCLItem.vendorSelected.vendor_code
            : null,
          vendor_name: formCLItem.vendorSelected
            ? formCLItem.vendorSelected.vendor_name
            : null,
          // payee_no: formCLItem.payeeSelected
          //   ? formCLItem.payeeSelected.vendor_code
          //   : null,
          // payee_name: formCLItem.payeeSelected
          //   ? formCLItem.payeeSelected.vendor_name
          //   : null,
          detail: formCLItem.detail,
          amount: formCLItem.amount,
          vat_rate: formCLItem.taxVatDefault,
          wh_tax_rate: formCLItem.taxWhDefault,
          vat: formCLItem.vat,
          wh_tax: formCLItem.whTax,
          is_itself_tax: formCLItem.isItselfTax ? 1 : 0,
          actual_cost: formCLItem.actualCost,

          budget_year: formCLItem.budgetInfo.year,
          budget_type: formCLItem.budgetInfo.subledger ? null : 'bu',
          budget_bu_code: formCLItem.budgetInfo.bu_code,
          budget_bu_name: formCLItem.budgetInfo.bu_name,
          budget_code: formCLItem.budgetInfo.account_code,
          budget_name: formCLItem.budgetInfo.account_name,

          budget_subsidiary:
            formCLItem.budgetInfo.subledger !== ''
              ? formCLItem.budgetInfo.subsidiary
              : null,
          budget_subledger:
            formCLItem.budgetInfo.subledger !== ''
              ? formCLItem.budgetInfo.subledger
              : null,
          budget_subledger_name:
            formCLItem.budgetInfo.subledger !== ''
              ? formCLItem.budgetInfo.subledger_name
              : null,

          invoice_no: '',
          invoice_date: '',
          history: null
        }
        if (formCLItem.clItemID === null) {
          await api
            .post('/reimbursement/cl/insertItem', dataItem)
            .then(async res => {
              if (res.code == 200) {
                alert.success('เพิ่มข้อมูล')
                items.value.push(res.data)
                clearFormItem()
                await reloadCL()
              } else {
                if (res.validator) {
                  alert.validatorShow(res.validator)
                } else {
                  alert.error(res.message)
                }
              }
            })
            .then(() => checkBudget())
            .catch(e => {
              alert.error(e.message)
              store.commit('cl/setBtnActiveFix', {
                type: 'btnItemSave',
                status: false
              })
            })
        } else {
          await api
            .put(
              `/reimbursement/cl/updateItem/${formCLItem.clItemID}`,
              dataItem
            )
            .then(async res => {
              if (res.code == 200) {
                alert.success('อัพเดทข้อมูล')
                clearFormItem()
                await reloadCL()
              } else {
                if (res.validator) {
                  alert.validatorShow(res.validator)
                } else {
                  alert.error(res.message)
                }
              }
            })
            .then(() => checkBudget())
            .catch(e => {
              alert.error(e.message)
              store.commit('cl/setBtnActiveFix', {
                type: 'btnItemSave',
                status: false
              })
            })
        }
        // reloadCL()
        store.commit('cl/setBtnActiveFix', {
          type: 'btnItemSave',
          status: false
        })

        return dataItem
      } else {
        alert.error()
      }
    }

    const setItems = data => {
      items.value = data.map(item => {
        return {
          receipt_no: item.receipt_no,
          receipt_date: item.receipt_date,
          detail: item.detail,
          amount: item.amount,
          vat: item.vat,
          wh_tax: item.wh_tax,
          actual_cost: item.actual_cost,
          cl_item_id: item.cl_item_id,
          is_edit: false,
          isOverBudget: false
        }
      })
    }

    const reloadCL = async () => {
      if (formCL.clID) {
        await api
          .get(
            `${process.env.VUE_APP_API_URL}/reimbursement/cl/getByClId/${formCL.clID}`
          )
          .then(res => {
            if (res.code == 200) {
              setItems(res.data.items)
              formCL.itemSummary = res.data.itemSummary
            }
          })
      }
    }

    const rejectCL = async () => {
      store.commit('cl/setBtnActive', { type: 'btnReject' })
      await api
        .put(
          `${process.env.VUE_APP_API_URL}/reimbursement/cl/editBeforeApprove/${formCL.clID}`
        )
        .then(res => {
          if (res.code == 200) {
            store.commit('cl/setBtn', { type: 'btnDraft', value: 'hide' })
            store.commit('cl/setBtn', { type: 'btnSave', value: 'hide' })
            store.commit('cl/setBtn', { type: 'btnReject', value: 'hide' })
            store.commit('cl/setBtnActive', { type: 'btnReject' })
          } else {
            alert.error(res.message)
          }
        })
    }

    const lockField = reactive({
      status: false,
      label: '(ไม่สามารถแก้ไขได้)'
    })

    const getCL = async () => {
      if (route.params.id) {
        await api
          .get(
            `${process.env.VUE_APP_API_URL}/reimbursement/cl/getByClId/${route.params.id}`
          )
          .then(res => {
            if (res.code == 200) {
              formCL.companySelected = res.data.cl_comp
              formCL.employeeSelected = res.data.req_id
              formCL.cashSelected = res.data.petty_cash
              formCL.telephone = res.data.telephone
              formCL.detail = res.data.req_detail
              formCL.payeeSelected = res.data.payee_no
              specialPathSelected.value = res.data.special_path
              // formCL.payFor = res.data.pay_for
              formCL.itemSummary = res.data.itemSummary
              formCL.caSelected = res.data.ca_id
              formCL.memoSelected = res.data.ememo_id
              formCL.statusCode = res.data.status_code
              formCL.clNo = res.data.doc_no_full
              formCL.historyArray = res.data.history_array

              formCL.approveResultArray = res.data.approve_result_array
              formCL.documentPathArray = res.data.document_path_array
              formCL.nextStatus = res.data.next_status

              if (res.data.doc_no_full != '') {
                lockField.status = true
              }

              store.commit(
                'cl/setDocumentPathText',
                res.data.document_path_text_array
              )
              store.commit('cl/setDocumentPath', res.data.document_path_array)
              for (const i in res.data.file_attach_array) {
                store.commit('cl/setFile', res.data.file_attach_array[i])
              }

              store.dispatch('global/loadDocumentSpacialPath', {
                compNo: res.data.cl_comp
              })

              if (res.data.ememo_id) {
                formCL.memoSelected = res.data.ememo_id
              }
              if (items.value.length > 0) {
                alertBudget(false, res.data.is_over_budget)
              }
              setItems(res.data.items)

              store.commit('cl/setBtn', { type: 'btnCancel', value: 'hide' })
              if (res.data.status_code != 'CL_DRAFT') {
                store.commit('cl/setBtn', { type: 'btnDraft', value: 'hide' })
                if (res.data.flag_edit === null || res.data.flag_edit === 0) {
                  store.commit('cl/setBtn', { type: 'btnSave', value: 'hide' })
                }
              }

              if (
                res.data.is_editing != 1 &&
                res.data.status_code == 'CMD_REVIEW'
              ) {
                store.commit('cl/setBtn', { type: 'btnReject', value: 'hide' })
              }
            } else {
              alert.error(res.message)
            }
          })
          .catch(e => {
            alert.error(e.message)
          })
      }
      // await store.commit('global/setLoadingPage', false)
      return true
    }

    const showVendor = ref()

    showVendor.value = formCL.cashSelected === 'c'

    watch(
      () => formCL.cashSelected,
      newVal => {
        if (!formCL.clEdit) {
          formCL.payeeSelected = null
          formCL.payeeName = ''
          formCL.payeeNo = ''
        }
        if (newVal != 'p') {
          showVendor.value = true
        } else {
          showVendor.value = false
        }
      }
    )

    watch(
      () => formCL.payeeSelected,
      newVal => {
        if (newVal) {
          formCL.payeeName = newVal.vendor_name
          formCL.payeeNo = newVal.vendor_code
        }
      }
    )

    // watch(
    //   [
    //     companyDefault,
    //     () => formCL.employeeSelected,
    //     () => formCL.cashSelected
    //   ],
    //   (newVal, oldVal) => {
    //     if (newVal[0] != oldVal[0]) {
    //       store.dispatch('global/loadDocumentSpacialPath', {
    //         compNo: companyDefault.value.comp_no
    //       })
    //       store.dispatch('cl/loadDocumentPath', {
    //         compNo: companyDefault.value.comp_no,
    //         employeeId: formCL.employeeSelected,
    //         specialPath: specialPathSelected.value,
    //         cashSelected: formCL.cashSelected
    //       })
    //     }
    //     specialPathSelected.value = null

    //     if (newVal[1] != oldVal[1] || newVal[2] != oldVal[2]) {
    //       store.dispatch('cl/loadDocumentPath', {
    //         compNo: companyDefault.value.comp_no,
    //         employeeId: formCL.employeeSelected,
    //         specialPath: null,
    //         cashSelected: formCL.cashSelected
    //       })
    //     }
    //   }
    // )

    const onChangeDocumentPath = async data => {
      // console.log('e: ', data)
      if (data.target == 'select-company') {
        store.commit('global/setCompanyDefault', { no: formCL.companySelected })
      }
      if (
        data.target == 'select-single-employee' ||
        data.target == 'select-company'
      ) {
        // loading special path option
        await store.dispatch('global/loadDocumentSpacialPath', {
          compNo: companyDefault.value.comp_no
        })
        specialPathSelected.value = null
      }
      await store.dispatch('cl/loadDocumentPath', {
        // compNo: companyDefault.value.comp_no,
        compNo: formCL.companySelected,
        employeeId: formCL.employeeSelected,
        specialPath: specialPathSelected.value,
        cashSelected: formCL.cashSelected
      })

      const company = store.getters['global/companyFind'](
        formCL.companySelected
      )

      if (company) {
        await store.dispatch('global/loadCashByCompany', {
          compCode: company.comp_code
        })
      }
    }

    watch(
      () => employeeDefault.value,
      newVal => {
        if (!formCL.clID && formCL.clNo == '') {
          formCL.telephone = newVal.telephone
        }
      }
    )

    watch(
      () => formCL.employeeSelected,
      () => {
        console.log('change employee')
        store.dispatch('cl/loadCa', {
          caId: formCL.caSelected,
          reqId: formCL.employeeSelected
        })
      },
      {
        immediate: true
      }
    )

    // const companyChange = () => {
    //   store.commit('global/setCompanyDefault', { no: formCL.companySelected })
    // }

    const alertBudget = (isLoading, isOver) => {
      if (isLoading) {
        store.commit('global/setOverBudget', {
          message: 'กำลังตรวจสอบ',
          isOver: true,
          show: true
        })
      } else {
        store.commit('global/setOverBudget', {
          message: isOver == 1 ? 'เกินงบประมาณ' : 'อยู่ในงบประมาณ',
          isOver: isOver == 1,
          show: true
        })
      }
    }

    const checkBudget = async () => {
      if (!formCL.clID || items.value.lenght == 0) {
        store.commit('global/resetOverBudget')
        return
      }
      alertBudget(true, 0)
      await api
        .get(`/reimbursement/cl/checkOverBudgetByDocId/${formCL.clID}`)
        .then(res => {
          if (res.code == 200) {
            alertBudget(false, res.data.is_over_budget)
            for (const i in items.value) {
              items.value[i].isOverBudget = res.data.is_over_by.includes(
                items.value[i].cl_item_id
              )
            }
            if (res.data.is_over_budget) {
              alert.error('เกินงบประมาณ')
            }
          } else {
            alertBudget(true, 0)
            alert.error(res.message)
          }
          return res.data
        })
        .catch(e => {
          alert.error(e.message)
        })
    }

    const summaryActualCost = () => {
      const a = formCLItem.amount
      const t = formCLItem.taxVatProcess
        ? (a * formCLItem.taxVatDefault) / 100
        : 0
      const wh = formCLItem.taxWhProcess
        ? (a * formCLItem.taxWhDefault) / 100
        : 0

      formCLItem.vat = formCLItem.taxVatProcess ? t : 0

      formCLItem.whTax = formCLItem.taxWhProcess ? wh : 0

      formCLItem.actualCost = numberFormat2(a - wh + t)
    }

    const calActualCost = () => {
      summaryActualCost()
    }

    const calVat = () => {
      formCLItem.actualCost = numberFormat2(
        formCLItem.amount + formCLItem.vat - formCLItem.whTax
      )
    }

    const calTax = () => {
      formCLItem.actualCost = numberFormat2(
        formCLItem.amount + formCLItem.vat - formCLItem.whTax
      )
    }

    const calVatProcess = () => {
      if (formCLItem.taxVatProcess) {
        if (formCLItem.taxVatDefault > 0 && formCLItem.taxVatDefault <= 100) {
          formCLItem.vat = (formCLItem.amount * formCLItem.taxVatDefault) / 100
        } else {
          formCLItem.vat = 0
        }
      } else {
        formCLItem.vat = 0
      }
      calVat()
    }

    const calTaxProcess = () => {
      if (formCLItem.taxWhProcess) {
        if (formCLItem.taxWhDefault > 0 && formCLItem.taxWhDefault <= 100) {
          formCLItem.whTax = (formCLItem.amount * formCLItem.taxWhDefault) / 100
        } else {
          formCLItem.whTax = 0
        }
      } else {
        formCLItem.whTax = 0
      }
      calTax()
    }
    const setBudget = val => {
      formCLItem.budgetInfo.year = val.year
      formCLItem.budgetInfo.bu_code = val.bu_code
      formCLItem.budgetInfo.bu_name = val.bu_name
      formCLItem.budgetInfo.subsidiary = val.subsidiary
      formCLItem.budgetInfo.subledger = val.subledger
      formCLItem.budgetInfo.subledger_name = val.subledger_name
      formCLItem.budgetInfo.account_code = val.account_code
      formCLItem.budgetInfo.account_name = val.account_name
      formCLItem.budgetInfo.bu_type = val.subledger
        ? 'งบประมาณโครงการ'
        : 'งบประมาณหน่วยงาน'
    }

    const items = ref([])
    const boxItemOpen = ref(false)
    const toggleBoxItemOpen = () => {
      clearFormItem()
      boxItemOpen.value = !boxItemOpen.value
    }

    const deleteCLItemID = ref(null)
    const setDeleteCLItem = id => {
      deleteCLItemID.value = id
    }
    const cancelDeleteCLItem = () => {
      deleteCLItemID.value = null
    }
    const confirmDeleteCLItem = async () => {
      const resDeleteCLItem = await api.delete(
        `reimbursement/cl/deleteItem/${deleteCLItemID.value}`
      )
      if (resDeleteCLItem.code == 200) {
        alert.success('ลบรายการ สำเร็จ')
        const newItems = await items.value.filter(item => {
          return item.cl_item_id != deleteCLItemID.value
        })
        items.value = newItems
        deleteCLItemID.value = null
        checkBudget()
      }
    }
    const rulesItem = {
      detail: { required }
      // vendorSelected: { required }
    }

    const validateItem = useVuelidate(rulesItem, toRefs(formCLItem))

    const clearFormItem = () => {
      validateItem.value.$reset()
      boxItemOpen.value = false
      if (formCLItem.clItemID !== null) {
        for (const i in items.value) {
          items.value[i].is_edit = false
        }
      }
      formCLItem.vendorSelected = null
      formCLItem.clItemID = null
      formCLItem.payeeSelected = null
      formCLItem.budgetSelected = null
      formCLItem.isItselfTax = false

      formCLItem.budgetInfo = {
        year: '',
        bu_name: '',
        bu_code: '',
        bu_type: '',
        subledger: '',
        subsidiary: '',
        account_code: '',
        account_name: '',
        subledger_name: ''
      }
      formCLItem.budgetSubledgerSelected = null
      formCLItem.bu_year = null
      formCLItem.bu_name = null
      formCLItem.receiptNo = null
      formCLItem.receiptDate = new Date()
      formCLItem.detail = null
      formCLItem.amount = 0
      formCLItem.vat = 0
      formCLItem.whTax = 0
      formCLItem.actualCost = 0
      formCLItem.taxVatDefault = 7
      formCLItem.taxWhDefault = 3
      formCLItem.taxVatProcess = false
      formCLItem.taxWhProcess = false
    }

    const getCLItem = async (clItemID, index) => {
      for (const i in items.value) {
        items.value[i].is_edit = false
      }
      items.value[index].is_edit = true
      await api
        .get(
          `${process.env.VUE_APP_API_URL}/reimbursement/cl/getItemById/${clItemID}`
        )
        .then(res => {
          if (res.code == 200) {
            boxItemOpen.value = true
            formCLItem.clItemID = res.data.cl_item_id
            formCLItem.receiptNo = res.data.receipt_no
            formCLItem.receiptDate = res.data.receipt_date
            formCLItem.vendorSelected =
              res.data.vendor_no != null ? res.data.vendor_no.toString() : null
            formCLItem.detail = res.data.detail
            formCLItem.amount = res.data.amount
            formCLItem.taxVatDefault = res.data.vat_rate
            formCLItem.taxWhDefault = res.data.wh_tax_rate
            formCLItem.vat = parseFloat(numberFormat2(res.data.vat))
            formCLItem.whTax = parseFloat(numberFormat2(res.data.wh_tax))
            formCLItem.actualCost = numberFormat2(res.data.actual_cost)
            formCLItem.isItselfTax = res.data.is_itself_tax == 1
            formCLItem.taxVatProcess = res.data.vat > 0
            formCLItem.taxWhProcess = res.data.wh_tax > 0
            formCLItem.budgetInfo = {
              year: res.data.budget_year,
              bu_name: res.data.budget_bu_name,
              bu_code: res.data.budget_bu_code,
              bu_type: res.data.budget_subledger
                ? 'งบประมาณโครงการ'
                : 'งบประมาณหน่วยงาน',
              subledger: res.data.budget_subledger,
              subsidiary: res.data.budget_subsidiary,
              account_code: res.data.budget_code,
              account_name: res.data.budget_name,
              subledger_name: res.data.budget_subledger_name
            }
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
      return true
    }

    const importProcess = ref(false)
    const importFile = async event => {
      if (formCL.clID === null) {
        await saveCL(true)
      }
      if (event.target.files[0]) {
        if (event.target.files[0].name.length <= 200) {
          if (formCL.clID !== null) {
            importProcess.value = true
            const formData = new FormData()
            formData.append('file', event.target.files[0])
            formData.append('doc_type', 'cl')
            formData.append('doc_id', formCL.clID)
            await apiImport
              .post('/import/docItem', formData)
              .then(res => {
                importProcess.value = false
                if (res.data.insert_fail > 0) {
                  const errorMsg = res.data.insert_fail_data.map(item => {
                    return `บรรทัดที่ ${item.line_fail}. ${item.message}`
                  })
                  alert.error(errorMsg.join('<br>') + '<br>กรุณาตรวจสอบ')
                } else {
                  alert.success()
                  reloadCL()
                }
              })
              .catch(e => {
                alert.error(e.message)
                importProcess.value = false
              })
          } else {
            event.target.value = null
          }
        } else {
          alert.error('ชื่อไฟล์ยาวเกิน 200 ตัวอักษร')
        }
      }
    }

    onMounted(async () => {
      console.log('mounted the cl form')

      await store.dispatch('global/loadCompany')
      store.dispatch('global/loadCurrency')
      // store.dispatch('global/loadCash')
      store.dispatch('global/loadFileUploadMaxSize')
      // store.dispatch('cl/loadPayFor')

      store.commit('cl/setBtn', { type: 'btnItemSave', value: 'hide' })
      store.commit('cl/setBtn', { type: 'btnSave', value: 'hide' })
      store.commit('cl/setBtn', { type: 'btnDraft', value: 'hide' })
      store.commit('global/resetOverBudget')

      if (!formCL.clEdit) {
        await store.dispatch('global/loadDocumentSpacialPath', {
          compNo: store.state.auth.info.comp_no
        })
        // formCL.payFor = store.getters['cl/getPayForDefault']
      }
      await getCL()
      store.dispatch('cl/loadMemo', { ememoId: formCL.memoSelected })
      store.commit('global/setCompanyDefault', { no: formCL.companySelected })
      await store.dispatch('cl/loadCa', {
        caId: formCL.caSelected,
        reqId: formCL.employeeSelected,
        cashSelected: formCL.cashSelected
      })
      // companyChange()
      await onChangeDocumentPath({ target: 'mounted' })
      await store.commit('global/setLoadingPage', false)
      if (formCL.clEdit) {
        await checkBudget()
      }
    })

    onUnmounted(() => {
      console.log('unmounted the ca form')

      store.commit('global/setLoadingPage', true)
      store.commit('cl/initBtn')
    })

    return {
      loadingPage,
      btnCancel,
      btnSave,
      btnDraft,
      btnReject,
      btnItemSave,
      userInfo,
      currencyOptions,
      cashOptions,
      documentPathText,
      companyOptions,
      documentSpacialPathOptions,
      memoOptions,
      companyDefault,
      specialPathSelected,
      files,
      fileUploadMaxSize,
      formCL,
      formCLItem,
      caOptions,
      // companyChange,
      saveCL,
      saveItem,
      rejectCL,
      setBudget,
      items,
      checkBudget,
      boxItemOpen,
      toggleBoxItemOpen,
      clearFormItem,
      numberFormat,
      dateFormat,
      getCLItem,
      setDeleteCLItem,
      cancelDeleteCLItem,
      confirmDeleteCLItem,
      validateItem,
      showVendor,
      calActualCost,
      calVat,
      calTax,
      calVatProcess,
      calTaxProcess,
      lockField,
      validateCL,
      onChangeDocumentPath,
      importProcess,
      importFile,
      employeeDefault,
      selectedMemo,
      linkImportXlsx,
      isProjectBudgetEnable
    }
  }
})
</script>
